import React from "react";
import PropTypes from "prop-types";

const ZoomControls = ({ zoomLevel, onZoom, onManualZoom }) => {
  return (
    <div
      style={{
        position: "fixed",
        right: "20px",
        bottom: "30px",
        display: "flex",
        gap: "8px",
        alignItems: "center",
        zIndex: 1,
        background: "#f7f7f7",
        borderRadius: "7px",
        boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
        padding: "4px 10px",
        border: "1px solid #e0e0e0",
      }}
    >
      <button
        onClick={() => onZoom(0.9)}
        className="zoom-button"
        style={{
          width: 25,
          height: 25,
          borderRadius: "50%",
          background: "#757e87",
          color: "#fff",
          border: "none",
          fontSize: 24,
          fontWeight: "bold",
          paddingBottom: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          outline: "none",
        }}
        aria-label="Zoom out"
      >
        -
      </button>

      <input
        type="text"
        value={Math.round(zoomLevel * 100) + "%"}
        onChange={onManualZoom}
        step="10"
        min="50"
        max="200"
        disabled
        className="zoom-input"
        style={{
          width: "48px",
          textAlign: "center",
          border: "none",
          background: "#fff",
          fontWeight: 500,
          fontSize: 14,
          color: "#6c757d",
          outline: "none",
          border: "1px solid #a4acaf",
          padding: "4px 0",
        }}
      />

      <button
        onClick={() => onZoom(1.1)}
        className="zoom-button"
        style={{
          width: 25,
          height: 25,
          borderRadius: "50%",
          background: "#757e87",
          color: "#fff",
          border: "none",
          fontWeight: "bold",
          fontSize: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          outline: "none",
        }}
        aria-label="Zoom in"
      >
        +
      </button>
    </div>
  );
};

ZoomControls.propTypes = {
  zoomLevel: PropTypes.number.isRequired,
  onZoom: PropTypes.func.isRequired,
  onManualZoom: PropTypes.func.isRequired,
};

export default ZoomControls;
